import { Autocomplete, Box, Button, Divider, FormControlLabel, Grid, IconButton, InputAdornment, Menu, MenuItem, Modal, Paper, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { Colors } from '../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithExtraFilter, CommonPatientDetails } from '../../Components/Common Components/CommonComponents'
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import SearchIcon from '@mui/icons-material/Search';
import RestAPIService from '../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../Utility/API/Serviceurls'
import { localGetItem } from '../../Utility/Services/CacheProviderService'
import { formatDate, formatDateAndTime, formatDateAndTimeMeth2, Time_convert } from '../../Components/CommonFunctions/CommonFunctions'
import ToastMsg from '../../Components/ToastMsg/ToastMsg'

const MrdTransfers = (props) => {
  const [view, setView] = useState('inbound')
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [inBoundList, setInBoundList] = useState([]);
  const [outBoundList, setOutBoundList] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [selectedPatient, setselectedPatient] = useState(null);
  const [patientSearch, setPatientSearch] = useState(false);
  const [SearchKey, setSearchKey] = useState("");
  const [LocationList, setLocationList] = useState([]);
  const [selectedLocation, setselectedLocation] = useState(null);
  const [searchLocation, setsearchLocation] = useState(null);
  const [patientSearchList, setPatientSearchList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [nurseList, setNurseList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedNurse, setSelectedNurse] = useState(null);
  const [fromLocation, setFromLocation] = useState(null);
  const [fromLocationID, setFromLocationID] = useState(null);
  const [fromLocationType, setFromLocationType] = useState(null);
  const [anchorEl, setanchorEl] = useState(null);

  let Docdetail = JSON.parse(localGetItem("loggedInUserInfo"))
  const ClinicID = Docdetail?.clinic_id || JSON.parse(localGetItem("SelectedDoctorClinicId"))

  useEffect(() => {
    fetchAndSetList('setDoctorList', Serviceurls.FO_CONFIG_OPDOCTORNAME);
    fetchAndSetList('setNurseList', Serviceurls.FO_STAFF_LIST);
    fetchAndSetList('setLocationList', Serviceurls.MRD_ROOMS_LIST + `?clinic_id=${ClinicID}`);
  }, [])

  useEffect(() => {
    getRequestDetails()
  }, [view])

  const fetchAndSetList = async (stateKey, url) => {
    const stateMap = {
      setPatientSearchList,
      setDoctorList,
      setLocationList,
      setNurseList,
    };

    try {
      setisloader(true);
      const response = await RestAPIService.getAll(url);
      if (response?.data?.status === 'success') {
        const listData = response?.data?.data || [];
        const setterFunction = stateMap[stateKey];
        if (setterFunction) {
          setterFunction(listData);
          if (listData.length > 0) {
            setDefaultFunc(listData, stateKey)
          }
        }
        if (stateKey === 'setPatientSearchList' && listData.length <= 0) {
          seterrorMsgText('No Records Found');
          seterrorMsg(true);
        } else if (stateKey === 'setPatientSearchList') {
          setPatientSearch(true);
        }
      }
    } catch (e) {
      const msg = e?.response?.data?.status === 'fail'
        ? e?.response?.data?.message
        : e?.message;
      seterrorMsgText(msg);
      seterrorMsg(true);
    } finally {
      setisloader(false);
    }
  };

  const setDefaultFunc = (listData, stateKey) => {
    let user = JSON.parse(localGetItem("loggedInUserInfo"))

    if (stateKey === "setLocationList") {
      if (user?.module_name === "master_record_department") {
        let location = listData.find((item) => item?.id == null)
        setselectedLocation(location)
      } else if (user?.module_name === 'Doctor') {
        let location = listData.find((item) => item?.doctor_id == user?.doctor_id)
        setselectedLocation(location)
        setsearchLocation(location)
      } else if (user?.module_name === 'nurse') {
        let location = listData.find((item) => item?.nurse_id == user?.nurse_id)
        setselectedLocation(location)
        setsearchLocation(location)
      }
    }
    if (stateKey === "setDoctorList") {
      if (user?.module_name === 'Doctor') {
        let location = listData.find((item) => item?.doctor_id == user?.doctor_id)
        setSelectedDoctor(location)
      }
    }
    if (stateKey === "setNurseList") {
      if (user?.module_name === 'nurse') {
        let location = listData.find((item) => item?.staff_id == user?.nurse_id)
        setSelectedNurse(location)
      }
    }
  }

  const changeView = (bound) => {
    if (bound === 'inbound') {
      setDefaultFunc(LocationList, 'setLocationList')
      setDefaultFunc(doctorList, 'setDoctorList')
      setDefaultFunc(nurseList, 'setNurseList')
      setView(bound)
    }
    if (bound === 'outbound') {
      let location = LocationList.find((item) => item?.id == null)
      setselectedLocation(location)
      setSelectedDoctor(null)
      setSelectedNurse(null)
      setView(bound)
    }
    ClearFuction()
  }

  const getRequestDetails = async () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_DOC_TRANSFER_GET_POST + `?clinic_id=${ClinicID}`)
        .then((response) => {
          if (response.data.status === 'success') {
            setInBoundList(response?.data?.inbound || []);
            setOutBoundList(response?.data?.outbound || []);
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            seterrorMsgText(e.response.data.message);
            seterrorMsg(true);
          } else {
            seterrorMsgText(e.message);
            seterrorMsg(true);
          }
        })
    } catch (e) {
      setisloader(false)
      seterrorMsgText(e.message);
      seterrorMsg(true);
    }
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  const ClearFuction = () => {
    setselectedPatient(null)
    setPatientSearch(false)
    setSearchKey("")
    setFromLocation(null)
  }

  const handleRequest = () => {
    try {
      if (!selectedPatient) {
        seterrorMsgText('Select the patient before request');
        seterrorMsg(true);
        return;
      }

      let returnType = (view === 'outbound');
      const data = {
        "patient_id": selectedPatient?.patient_id,
        "request_to": selectedLocation?.type,
        "request_to_id": selectedLocation?.id,
        'clinic_id': ClinicID,
        'request_from': fromLocationType === 'MRD Home' ? 'MRD' : fromLocationType,
        'request_from_id': fromLocationID || null,
        'return_back': returnType || false,
        'clinic_id': ClinicID
      };
      setisloader(true);
      RestAPIService.create(data, Serviceurls.MRD_DOC_TRANSFER_GET_POST).then((response) => {
        if (response?.data?.status === 'success') {
          setsuccessMsgText(response.data.message);
          setsuccessMsg(true);
          ClearFuction()
          getRequestDetails()
        }
      }).catch(e => {
        setisloader(false)
        if (e?.response?.data?.status === 'fail') {
          seterrorMsgText(e.response.data.message);
          seterrorMsg(true);
        } else {
          seterrorMsgText(e?.message || e?.response?.data?.message);
          seterrorMsg(true);
        }
      })
    } catch (error) {
      seterrorMsgText(error?.message || 'Request failed');
      seterrorMsg(true);
    } finally {
      setisloader(false);
    }
  }

  const handleAction = async (action = '', item) => {
    try {
      const data = {
        action: action,
        patient_id: item?.patient_id,
        clinic_id: ClinicID
      };
      setisloader(true);
      const response = await RestAPIService.patch(data, Serviceurls?.MRD_DOC_TRANSFER_GET_POST + `${item?.id}/action/`);

      if (response.data.status === "success") {
        getRequestDetails()
        setisloader(false);
      }
    } catch (error) {
      setisloader(false);
      if (error?.response?.data?.status === 'fail') {
        seterrorMsgText(error?.response?.data?.message || 'Request failed');
        seterrorMsg(true);
      } else {
        seterrorMsgText(error?.message || 'Request failed');
        seterrorMsg(true);
      }
    }
  };


  const renderLeftSide = () => {
    let user = JSON.parse(localGetItem("loggedInUserInfo"))
    try {
      return (
        <Box>
          <Typography sx={{ padding: "0.5dvw", fontWeight: 600 }}>{view === 'inbound' ? "Request MRD Document" : "Send MRD Document"}</Typography>
          <Divider />
          <Box padding={'0.3dvw'}>
            <TextField
              size='small'
              autoComplete='off'
              placeholder={"Search Patient"}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      if (SearchKey.trim() !== "" && SearchKey?.length > 2) {
                        if (user?.module_name !== 'master_record_department' && view === 'outbound') {
                          fetchAndSetList('setPatientSearchList', Serviceurls.MRD_DOCUMENTS_ADD + `?search=${SearchKey}&current_location_id=${searchLocation?.id}&current_location_type=${user?.module_name}&clinic_id=${ClinicID}`);
                        } else {
                          fetchAndSetList('setPatientSearchList', Serviceurls.MRD_DOCUMENTS_ADD + `?search=${SearchKey}&clinic_id=${ClinicID}`);
                        }
                      }
                    }}
                    emed_tid="mrd_transfers_patient_search_btn"
                    variant="contained"
                    size='small'
                    edge="end"
                  >
                    {<SearchIcon color='primary' />}
                  </IconButton>
                </InputAdornment>
              }}
              sx={{ width: '18vw' }}
              value={SearchKey || ""}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && SearchKey.trim() !== "" && SearchKey?.length > 2) {
                  if (user?.module_name !== 'master_record_department' && view === 'outbound') {
                    fetchAndSetList('setPatientSearchList', Serviceurls.MRD_DOCUMENTS_ADD + `?search=${SearchKey}&current_location_id=${searchLocation?.id}&current_location_type=${user?.module_name}&clinic_id=${ClinicID}`);
                  } else {
                    fetchAndSetList('setPatientSearchList', Serviceurls.MRD_DOCUMENTS_ADD + `?search=${SearchKey}&clinic_id=${ClinicID}`);
                  }
                }
              }}
              onChange={(e) => {
                setselectedPatient(null)
                setanchorEl(e.currentTarget)
                setSearchKey(e.target.value)
              }}
              emed_tid="mrd_transfers_patient_search_input" />
            <Menu
              open={patientSearch}
              anchorEl={anchorEl}
              sx={{ marginTop: "6dvh" }}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              onClose={() => {
                setPatientSearch(false)
              }}
              elevation={1}
            >
              {
                patientSearchList.length > 0 ?
                  patientSearchList.map((list, index) => (
                    <MenuItem emed_tid={`mrd_transfers_patient_suggestion_${index}`}
                      autoFocus={index === 0}
                      onClick={() => {
                        setSearchKey("")
                        setselectedPatient(list)
                        setFromLocation(list?.current_location)
                        setFromLocationID(list?.current_location_id || null)
                        setFromLocationType(list?.current_location_type)
                        setPatientSearch(false)
                      }}
                      key={index}>
                      <Box><CommonPatientDetails data={list} /></Box>
                    </MenuItem>
                  )) : null
              }
            </Menu>
            <TextField
              size='small'
              disabled
              autoComplete='off'
              value={fromLocation || ''}
              sx={{ width: "18dvw", marginTop: "1dvh" }}
              label={"Location From *"}
              variant="outlined"
              emed_tid="mrd_transfers_location_from_input"
            />
            <Autocomplete
              clearIcon
              size='small'
              sx={{ width: "18dvw", marginTop: "1dvh" }}
              options={LocationList}
              disabled
              getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.name}
              renderOption={(props, option) => (
                <Box component="li"
                  {...props}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} >
                    {`${option?.name || "-"}`}
                  </Typography>
                  <Typography
                    fontSize=".8vw"
                    fontWeight="bold"
                    sx={{ width: "100%", textAlign: "left" }}
                    color={option?.type === 'Doctor' ? "#29B6F6"
                      : option?.type === 'Nurse' ? "#1E972A"
                        : option?.type === 'Other' ? "#f15506ff"
                          : option?.type === 'MRD' ? "blue"
                            : "inherit"}
                  >
                    {option?.type === 'Doctor' ? "Doctor"
                      : option?.type === 'Nurse' ? "Nurse"
                        : option?.type === 'Other' ? "Other"
                          : option?.type ? 'MRD'
                            : ""}
                  </Typography>
                </Box>
              )}
              value={selectedLocation}
              onChange={(e, value) => {
                setselectedLocation(value)
              }}
              renderInput={(params) => <TextField autoComplete='off' disabled {...params} label={"Ward / Room No *"} emed_tid="mrd_transfers_ward_room_autocomplete" />}
            />
            {user?.module_name !== 'nurse' ?
              <Autocomplete
                clearIcon
                size='small'
                disabled
                sx={{ width: "18dvw", marginTop: "1dvh", marginBottom: "0.5vw" }}
                options={doctorList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                value={selectedDoctor}
                onChange={(e, value) => {
                  setSelectedDoctor(value)
                }}
                renderInput={(params) => <TextField autoComplete='off' disabled {...params} label={"Doctor Name"} emed_tid="mrd_transfers_doctor_autocomplete" />}
              /> :
              <Autocomplete
                clearIcon
                size='small'
                disabled
                sx={{ width: "18dvw", marginTop: "1dvh", marginBottom: "0.5vw" }}
                options={nurseList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.nurse}
                value={selectedNurse}
                onChange={(e, value) => {
                  setSelectedNurse(value)
                }}
                renderInput={(params) => <TextField autoComplete='off' disabled {...params} label={"Nurse Name"} emed_tid="mrd_transfers_nurse_autocomplete" />}
              />}
            <Divider />
            <Typography sx={{ padding: "0.5dvw", marginTop: "0.5vw" }}>{"Patient Details"}</Typography>

            <Box sx={{ padding: "0.5vw", height: '35dvh' }}>
              {selectedPatient ? <CommonPatientDetails data={selectedPatient} /> : null}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' , visibility : props?.Access?.editAccess ? "visible" : "hidden" }}>
              <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', marginRight: "1dvw" }}
                onClick={() => { ClearFuction() }}
                emed_tid="mrd_transfers_clear_btn"
              >Clear</Button>
              <Button size='small' variant='contained' onClick={handleRequest}
                disabled={isloader || (user?.module_name === "master_record_department" && view === 'outbound')} sx={{ textTransform: 'capitalize' }}
                emed_tid={view === 'inbound' ? "mrd_transfers_request_btn" : "mrd_transfers_send_btn"}
              >{view === 'inbound' ? "Request" : "Send"}
              </Button>
            </Box>
          </Box>
        </Box>
      )
    } catch (e) {

    }
  }

  const renderRightSide = () => {
    const gridToolBar = () => {
      return (
        <Box>
          <CommonGridToolBarWithExtraFilter />
        </Box>
      )
    }
    (view === 'inbound' ? inBoundList : outBoundList)?.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: 'reorder_threshold', headerName: 'Patient Details', flex: 0.2,
        renderCell: (params) => (<Box component={'div'}>{<CommonPatientDetails data={params?.row} />}</Box>)
      },
      ...(view === 'inbound' ?
        [{
          field: 'location_from', headerName: 'Requested To', flex: 0.15,
          renderCell: (params) => (params.row.location_from ? params.row.location_from?.length > 30 ?
            <Tooltip placement="top" title={params.row.location_from}><Typography sx={{ textTransform: 'capitalize' }} fontSize={'0.9vw'}>{params.row.location_from?.slice(0, 27) + '...'}</Typography></Tooltip> :
            <Typography sx={{ textTransform: 'capitalize' }} fontSize={'0.9vw'}>{params.row.location_from || '-'}</Typography> : '-')
        },] : [{
          field: 'location_to', headerName: 'Requested From', flex: 0.15,
          renderCell: (params) => (params.row.location_to ? params.row.location_to?.length > 30 ?
            <Tooltip placement="top" title={params.row.location_to}><Typography sx={{ textTransform: 'capitalize' }} fontSize={'0.9vw'}>{params.row.location_to?.slice(0, 27) + '...'}</Typography></Tooltip> :
            <Typography sx={{ textTransform: 'capitalize' }} fontSize={'0.9vw'}>{params.row.location_to || '-'}</Typography> : '-')
        },]),
      {
        field: 'requested_date', headerName: 'Requested Date & Time', flex: 0.2, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.requested_date ? `${formatDateAndTimeMeth2(params?.row?.requested_date)}` : '-'}</Box>)
      },
      // {
      //   field: 'last_visited_date', headerName: 'Username/Doctor/SL name', flex: 0.18,
      //   renderCell: (params) => (params.row.last_visited_date ? params.row.last_visited_date?.length > 12 ?
      //     <Tooltip placement="top" title={params.row.last_visited_date}><Typography fontSize={'0.9vw'}>{params.row.last_visited_date?.slice(0, 12) + '...'}</Typography></Tooltip> :
      //     <Typography fontSize={'0.9vw'}>{params.row.last_visited_date || '-'}</Typography> : '-')
      // },
      {
        field: 'status', headerName: 'Status', flex: 0.15,
        renderCell: (params) => (<Box component={'div'}>{params?.row?.status ? (params?.row?.status === 'Pending' && view === 'inbound' ? 'Initiated' : params?.row?.status === 'Transferred' ? 'In Transit' : params?.row?.status) : '-'}</Box>)
      },
      {
        field: 'action', headerName: 'Action', flex: 0.15,
        renderCell: (params) => (<Box component={'div'} sx={{ visibility : props?.Access?.editAccess ? "visible" : "hidden"}}>{
          view === "inbound" ?
            (params?.row?.inbound_status === 'pending' ?
              <Button
                sx={{ textTransform: 'capitalize', width: "8dvw" }}
                variant="contained"
                disabled
                size="small"
              >Pending</Button>
              :
              params?.row?.inbound_status === 'Received' ?
                <Button
                  startIcon={<BrowserUpdatedIcon />}
                  sx={{ textTransform: 'capitalize', width: "8dvw" }}
                  disabled
                  variant="contained"
                  size="small"
                >Received</Button>
                :
                <Button
                  startIcon={<BrowserUpdatedIcon />}
                  sx={{ textTransform: 'capitalize', width: "8dvw" }}
                  onClick={() => handleAction('receive', params?.row)}
                  variant="contained"
                  size="small"
                  emed_tid={`mrd_transfers_receive_btn_${params.row.sno}`}
                >Receive</Button>)
            :
            (params?.row?.outbound_status === 'In Transit' ?
              <Button
                sx={{ textTransform: 'capitalize', width: "8dvw" }}
                disabled
                variant="contained"
                size="small"
              >Transfered</Button>
              :
              <Button
                startIcon={<ContentPasteGoIcon />}
                sx={{ textTransform: 'capitalize', width: "8dvw" }}
                onClick={() => handleAction('send', params?.row)}
                variant="contained"
                size="small"
                emed_tid={`mrd_transfers_send_btn_${params.row.sno}`}
              >Send</Button>)
        }</Box>)
      },
    ];
    return (
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography sx={{ padding: "0.5dvw", fontWeight: 600 }}>{"MRD Documents"}</Typography>
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: 'center', marginRight: '0.5dvw' }}>
            <div onClick={() => changeView('inbound')} style={{ border: "1px solid gray", borderRight: 'none', width: "6.5vw", height: "2vw", cursor: "pointer", textAlign: "center", backgroundColor: view === 'inbound' ? Colors.themeBackgroud : null, paddingTop: "0.3vw", color: view === 'inbound' ? 'white' : null, fontSize: "0.9vw" }} emed_tid="mrd_transfers_inbound_tab">Inbound</div>
            <div onClick={() => changeView('outbound')} style={{ border: "1px solid gray", borderLeft: "none", width: "6.5vw", height: "2vw", cursor: "pointer", textAlign: "center", backgroundColor: view === 'outbound' ? Colors.themeBackgroud : null, paddingTop: "0.3vw", color: view === 'outbound' ? 'white' : null, fontSize: "0.9vw" }} emed_tid="mrd_transfers_outbound_tab">Outbound</div>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ height: '72vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={view === 'inbound' ? inBoundList : outBoundList}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      </Box>
    )
  }
  return (
    <Box component={"div"} className={'eMed_bill_container'}>
      <Grid container className={'eMed_bill_content'} >
        <Grid container className={'eMed_bill_content1'} spacing={1}>
          <Grid item xs={2.5}>
            <Paper sx={{ height: '78dvh', marginTop: "1dvh", marginLeft: "1dvh" }}>
              {renderLeftSide()}
            </Paper>
          </Grid>
          <Grid item xs={9.5}>
            <Paper sx={{ height: '78dvh', marginTop: "1dvh" }}>
              {renderRightSide()}
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  )
}

export default MrdTransfers